import { FC } from 'react';
import { FillerPrompts } from '@app/form_components/FillerPrompts';

export const SettingsFillerPromptPage: FC = () => {
  return (
    <FillerPrompts />
  );
};
